export default __webpack_public_path__ + "static/media/payment-blank.a9bbd96b.svg";